import React from 'react'
import './CallforPapers.css'
const CallforPapers = () => {
    return (
        <div className="CallforPapers">
            <h1 className="cfp">Call for papers</h1>
            <ol>
                <h3 className="tite"><i className="fa-solid fa-hand-point-right"></i> Computer engineering</h3>
                <ul className="liste">
                    <li>Intelligent Computing</li>
<li>Database Management Systems</li>
<li>Software Engineering</li>
<li>Systems Software</li>
<li>Data Communication &amp; Networking</li>
<li>Internet of Things</li>
<li>Management Information System</li>
<li>Bio Inspired Computing</li>
<li>Bioinformatics</li>
<li>Computer Vision</li>
<li>Expert Systems</li>
<li>Image Processing</li>
<li>Information Retrieval and Fusion</li>
<li>Data Engineering</li>
<li>Data Mining</li>
<li>Data Warehousing</li>
<li>Compiler Design</li>
<li>Computer System Modeling & Operating System </li>

<li>Parallel and Distributed Computing</li>
                </ul>
                <h3 className="tite"><i className="fa-solid fa-hand-point-right"></i> Business Intelligence & Data Science</h3>
                    <ul className="liste">
                   
<li>Emerging Trends in Information Technology and Business Analytics</li>
<li>Internet Addiction</li>
<li>Blockchain the Future Technology</li>
<li>Applications of Artificial Intelligence &amp; Machine Learning</li>
<li>Remote Management of Technology Infrastructure</li>
<li>Financial Informatics</li>
<li>Business Process Optimization</li>
<li>Gamification Technologies, Neuromarketing, VR, AR, and Mixed Reality</li>
<li>Big Data and Analytics</li>
<li>Generative AI</li>
<li>Cloud Computing</li>
<li>Cloud Security</li>
<li>Algorithmic Trading</li>
<li>Time Series Forecasting</li>
                </ul>
                <h3 className="tite"><i className="fa-solid fa-hand-point-right"></i> Electrical and Electronics</h3>

                <ul className="liste">
                   <li>Advanced Control Strategies in Electric Vehicle</li>
<li>Smart Grids, Energy Systems &amp; Renewable Integration</li>
<li>Sustainable Energy &amp; Reduction in Carbon Footprint – Associated Studies</li>
<li>Power Quality Issues &amp; Mitigation Techniques</li>
<li>FACTS, HVDC &amp; Custom Power Devices</li>
<li>High Voltage &amp; Power Engineering Applications</li>
<li>Hybrid EV, Plug-In Hybrid EV &amp; Fuel Cell EV</li>
<li>Vehicle to Grid, Vehicle to Building/Critical Loads</li>
<li>Autonomous Vehicle Technologies</li>
<li>Energy Storage System</li>
<li>Grid Reliability, Resilience – New Advances</li>
<li>Autonomous Vehicle</li>
<li>Software Defined Vehicle</li>
<li>IoT &amp; Digital Twinning</li>
<li>Cyber Security in Automotive</li>
<li>AI in Automotive</li>
<li>EMI &amp; EMC Studies</li>
<li>Energy Management</li>
<li>Advanced Material for PV Cells</li>
<li>Intelligent Power Electronic Systems</li>
<li>Vehicular Communication Techniques</li>
                </ul>
                <h3 className="tite"><i className="fa-solid fa-hand-point-right"></i> Electronics and Communication</h3>

                <ul className="liste">
                    <li>Signal Processing</li>
<li>VLSI Design</li>
<li>Antenna Engineering</li>
<li>Photonic/Opto Electronic Structures/Devices</li>
<li>Nanophotonics</li>
<li>Consumer Electronics</li>
<li>Smart Electronics Systems</li>
<li>Low Power VLSI Circuits &amp; Mixed Mode VLSI</li>
<li>Satellite Communication</li>
<li>VLSI Verification and Testing</li>
<li>Robotics and Automation</li>
<li>Next Generation Networks</li>
<li>Optical and Photonic Networks</li>
<li>Spread Spectrum Communication</li>
<li>Sensors &amp; Networks</li>
<li>Embedded Systems</li>
<li>Communication Systems</li>
<li>Quantum Computing</li>
<li>VLSI &amp; VHDL Design &amp; Applications</li>
<li>MEMS &amp; Medical Electronics</li>
<li>Cyber Security &amp; AI in Automotive</li>
                </ul>
            </ol>
        </div>
    )
}

export default CallforPapers